import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyRecommendationViewQuery,
  useRecommendationCreateMutation,
  useRecommendationUpdateMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const Recommendation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;
  const [btn, setBtn] = useState(false);

  const [name, setname] = useState("");
  const [amount, setamount] = useState("");
  const [no_of_validity, setno_of_validity] = useState("");
  const [nameErr, setnameErr] = useState(false);
  const [amountErr, setamountErr] = useState(false);
  const [no_of_validityErr, setno_of_validityErr] = useState(false);

  const [createApi] = useRecommendationCreateMutation();
  const [updateApi] = useRecommendationUpdateMutation();
  const [viewApi] = useLazyRecommendationViewQuery();

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      amount?.length == 0 ||
      no_of_validity?.length == 0
    ) {
      setnameErr(true);
      setamountErr(true);
      setno_of_validityErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("amount", amount);
      formdata.append("no_of_days", no_of_validity);

      dispatch(saveLoader(true));
      setBtn(true);
      if (location?.state?.type == "edit") {
        formdata.append("_method", "PUT");
        updateApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: "Recommendation Edited Successfully",
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            console.log("err", err);
            dispatch(saveLoader(false));
            setBtn(false);
          });
      } else {
        createApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: "Recommendation Added Successfully",
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            console.log("err", err);
            dispatch(saveLoader(false));
            setBtn(false);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        let data = res?.recommendation;
        if (data?.name) {
          setname(data?.name);
        }

        if (data?.amount) {
          setamount(data?.amount);
        }

        if (data?.no_of_days) {
          setno_of_validity(data?.no_of_days);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.type == "edit") {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={
          types == "view"
            ? "view-recommendation"
            : types == "edit"
            ? "edit-recommendation"
            : "add-recommendation"
        }
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Recommendation Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setname(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Recommendation Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Validity in days{" "}
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setno_of_validity(e.target.value)}
                  value={no_of_validity}
                  type={"number"}
                />
              </div>
              {no_of_validity?.length == 0 && no_of_validityErr && (
                <p className="err">Enter Validity in days</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Amount{" "}
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setamount(e.target.value)}
                  value={amount}
                  type={"number"}
                />
              </div>
              {amount?.length == 0 && amountErr && (
                <p className="err">Enter Amount</p>
              )}
            </div>
          </Row>
          <Row>
            {types == "view" ? null : (
              <div className="col-md-12 text-center mt-4 mb-4">
                <button
                  className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                  onClick={() => submitHandler()}
                  disabled={btn}
                >
                  Save
                </button>
              </div>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Recommendation;
